module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Alicja_Strzalkowska.42d63605.jpg";